/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Add_PaceInputs */

const en_ui_thresholds_add_pace = /** @type {(inputs: Ui_Thresholds_Add_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add threshold pace`)
};

const de_ui_thresholds_add_pace = /** @type {(inputs: Ui_Thresholds_Add_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwellentempo eintragen`)
};

/**
* | output |
* | --- |
* | "Add threshold pace" |
*
* @param {Ui_Thresholds_Add_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_add_pace = /** @type {((inputs?: Ui_Thresholds_Add_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Add_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_add_pace(inputs)
	return de_ui_thresholds_add_pace(inputs)
});